import { index as searchApi } from '@afosto/content/api/Index';

const DEFAULT_OPTIONS = {
  isFuzzy: false,
};

/**
 * Fetch multiple products
 * @param {array} values
 * @param {object} options
 * @param {string} options.key
 * @param {boolean} options.isFuzzy
 * @param {object} requestOptions
 * @returns {array<object[]>}
 */
export default async (values, options = {}, requestOptions = {}) => {
  try {
    const uniqueValues = [...new Set(values)];

    if (!uniqueValues?.length) {
      return [];
    }

    const { isFuzzy } = { ...DEFAULT_OPTIONS, ...options };
    const response = await searchApi.search(
      {
        codes: ['pim'],
        models: ['products'],
        namespaces: ['default'],
        q: uniqueValues,
        is_fuzzy: isFuzzy,
      },
      requestOptions,
    );
    const { data } = response;

    return data.hits.reduce((acc, productData) => [...acc, productData.metadata], []);
  } catch (err) {
    return [];
  }
};
